import React from 'react';

import { AiOutlineWarning } from 'react-icons/ai';

import {
  Container,
  Title,
  SubTitle,
  ButtonOK,
  TitleWrap,
  CardInfoIcon,
} from './styles';

type ModalErrorProps = {
  closeModal: () => void;
  stepError: number;
};

const ModalError: React.FC<ModalErrorProps> = ({ closeModal, stepError }) => {
  const errorMap: { [key: number]: string } = {
    1: 'Para prosseguir é necessário que alguma opção seja selecionada.',
    2: 'Para prosseguir, verifique e atualize o nível de gás em todas as bases selecionadas. Indique o nível atual ajustando o cursor do medidor ou digitando o valor no campo correspondente.',
    3: 'Para prosseguir é necessário que todas as bases selecionadas tenham uma data de agendamento.',
    4: 'Para prosseguir é necessário preencher os dados do responsável pelo recebimento.',
  };

  return (
    <Container>
      <TitleWrap>
        <CardInfoIcon>
          <AiOutlineWarning size={24} color="#E74141" />
        </CardInfoIcon>
        <Title>{stepError > 1 ? 'Ações pendentes' : 'Ação pendente'}</Title>
      </TitleWrap>
      <SubTitle>
        {errorMap[stepError] || 'Ocorreu um erro inesperado, tente novamente.'}
      </SubTitle>
      <ButtonOK onClick={() => closeModal()}>Entendi</ButtonOK>
    </Container>
  );
};

export default ModalError;
